import axiosIns from '@/libs/axios'
import { objectToUrlParam } from '@/libs/helper'

export default class FiatApis {
  getFiatInfo = async data => await axiosIns.get('wallet', data);

  getCurrency = async data => await axiosIns.get(`crypto/crypto-wire/currencies${objectToUrlParam(data)}`);

  saveWithdrawal = async data => await axiosIns.post('withdrawal-ticket-bank-module/store', data)

  bankAccountInfo = async data => await axiosIns.get(`crypto/crypto-wire/banks${objectToUrlParam(data)}`, {
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded',
    // },
  })

  saveDeposit = async data => {
    const formData = new FormData()
    Object.keys(data).forEach(element => formData.append(element, data[element]))
    return await axiosIns.post('crypto/crypto-wire/deposits', formData)
  }

  getDeposits = async data => await axiosIns.get(`crypto/crypto-wire/deposits${objectToUrlParam(data)}`);

  getWithdrawals = async data => await axiosIns.get(`crypto/crypto-wire/withdrawals${objectToUrlParam(data)}`);
}
